import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  Slider, Rail, Handles, Tracks, Ticks,
} from 'react-compound-slider';
import { scaleTime } from 'd3-scale';
import useResponsive from 'hooks/useResponsive';
import { subDays, startOfToday, format } from 'date-fns';
import moment from 'moment';
import useStores from 'hooks/useStore';
import {
  SliderRail, Handle, Track, Tick,
} from './components';

import { Container, Wrapper, InnerContainer } from './styles';

const sliderStyle = {
  position: 'relative',
  width: '100%',
};

function formatTick(ms) {
  return format(new Date(ms), 'MMM yy');
}

const OneDay = 1000 * 60 * 60 * 24;

const RangeSlider = observer(() => {
  const {
    UIStore: {
      dateRange, min, max, selectedStartDate, selectedEndDate,
      updatedStartDate, updatedEndDate, onChange, onUpdate,
    },
  } = useStores();

  const { isLargeView } = useResponsive();

  const dateTicks = scaleTime()
    .domain([+min, +max])
    .ticks(10)
    .map((d) => +d);

  if (dateRange.length < 1) {
    return null;
  }

  return (
    <Container>
      <InnerContainer>
        <Slider
          mode={1}
          step={OneDay}
          domain={[+min, +max]}
          rootStyle={sliderStyle}
          onUpdate={onUpdate}
          onChange={onChange}
          values={[+selectedStartDate, +selectedEndDate]}
        >
          <Rail>
            {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
          </Rail>
          <Handles>
            {({ handles, getHandleProps }) => (
              <div>
                {handles.map((handle) => (
                  <Handle
                    isLargeView={isLargeView}
                    key={handle.id}
                    handle={handle}
                    domain={[+min, +max]}
                    getHandleProps={getHandleProps}
                  />
                ))}
              </div>
            )}
          </Handles>
          <Tracks left={false} right={false}>
            {({ tracks, getTrackProps }) => (
              <div>
                {tracks.map(({ id, source, target }) => (
                  <Track
                    key={id}
                    source={source}
                    target={target}
                    getTrackProps={getTrackProps}
                  />
                ))}
              </div>
            )}
          </Tracks>
          <Ticks values={dateTicks}>
            {({ ticks }) => (
              <div>
                {ticks.map((tick) => (
                  <Tick
                    isLargeView={isLargeView}
                    key={tick.id}
                    tick={tick}
                    count={ticks.length}
                    format={formatTick}
                  />
                ))}
              </div>
            )}
          </Ticks>
        </Slider>
      </InnerContainer>
    </Container>
  );
});

export default RangeSlider;
